__turbopack_context__.v({
  "carousel": "pEsxHG_carousel",
  "container": "pEsxHG_container",
  "grid": "pEsxHG_grid",
  "hidden": "pEsxHG_hidden",
  "nextButton": "pEsxHG_nextButton",
  "root": "pEsxHG_root",
  "scrollArea": "pEsxHG_scrollArea",
});
